import styled from '@emotion/styled';

import StyledTypography from './StyledTypography';

const RecaptchaTypography = styled(StyledTypography)({}, ({ theme }) => ({
  a: {
    color: theme.palette.colors.coolGrey,
    fontSize: theme.typography.fontSize.small
  }
}));

export default RecaptchaTypography;
